/* unplugin-vue-components disabled */import { render } from "./mimo-replace.vue?vue&type=template&id=3c137cb3"
import script from "./mimo-replace.vue?vue&type=script&lang=js"
export * from "./mimo-replace.vue?vue&type=script&lang=js"

import "./mimo-replace.vue?vue&type=style&index=0&id=3c137cb3&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__